'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { FC } from 'react'

interface FeaturedCollection {
  title: string
  imageUrl: string
  filter: string
}

interface GraphicTeeFeaturedProps {
  collections: FeaturedCollection[]
}

export const GraphicTeeFeatured: FC<GraphicTeeFeaturedProps> = ({
  collections,
}) => {
  const router = useRouter()
  const handleChangeFilter = (filter: string) => {
    router.replace(`?bo-suu-tap=${filter}`, { scroll: false })

    // Cuộn đến phần CollectionContainer có className='lg:py-20'
    setTimeout(() => {
      const collectionHeader = document.querySelector(
        '.collection-header-section'
      )
      if (collectionHeader) {
        collectionHeader.scrollIntoView({ behavior: 'smooth' })
      }
    }, 100) // Đợi một chút để URL được cập nhật
  }
  return (
    <div className='pt-10'>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
        {collections.map((collection, index) => (
          <div key={index}>
            <div
              className='relative aspect-[16/9]'
              onClick={() => handleChangeFilter(collection.filter)}
            >
              <Image
                src={ImageHelper.getImageUrlCdn(collection.imageUrl)}
                alt={collection.title}
                fill
                className='object-cover transition-transform duration-300 group-hover:scale-105'
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
